"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReferralLink = void 0;
// The app runs on a HashRouter, so the referral query must be inside the hash.
// Deriving the base from the active page keeps DEV, PROD and custom domains aligned.
function buildReferralLink(referralCode) {
    var baseUrl = "".concat(window.location.origin).concat(window.location.pathname);
    return "".concat(baseUrl, "#/home?referral_code=").concat(encodeURIComponent(referralCode));
}
exports.buildReferralLink = buildReferralLink;
